import React, { useState } from "react";

import { connect } from "react-redux";

import { IconButton } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import "../order.css";
import { rejectingOrder } from "../../../../actions/sellerActions";

const RejectingOrder = (props) => {
  const [reason, setReason] = useState(null);

  return (
    <div style={{ textAlign: "center", margin: "10px 0 30px" }}>
      <h2 className="summary">Rejecting Order</h2>
      <div style={{ margin: "30px" }}>
        <textarea
          rows={8}
          cols={50}
          placeholder="Reason Of Rejection"
          onChange={(e) => setReason(e.target.value)}
        />
      </div>
      <IconButton
        variant="outlined"
        style={{
          color: "white",
          backgroundColor: "red",
          margin: "15px",
          borderRadius: "10px",
        }}
        onClick={() => {
          props.rejectingOrder(props.match.params.orderID, reason);
          props.history.push(`/dashboard/${props.auth.seller._id}`);
        }}
      >
        <Cancel style={{ marginRight: "15px" }} />{" "}
        <p style={{ fontSize: 14 }}>Confirm Rejection</p>
      </IconButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { rejectingOrder })(RejectingOrder);
